export default __webpack_public_path__ + "static/career_01-76951cbe970dd61f8df5e09f004a82a4.svg";